<div class="min-h-screen bg-linear-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
  <div class="w-full max-w-md">
    <!-- 登入卡片 -->
    <div class="bg-white rounded-2xl shadow-xl p-8 space-y-6 fade-in hover-card">
      <!-- 標題區域 -->
      <div class="text-center space-y-2">
        <div
          class="w-16 h-16 bg-linear-to-r from-blue-500 to-indigo-600 rounded-full mx-auto flex items-center justify-center">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
        </div>
        <h2 class="text-2xl font-bold text-gray-800">使用者登入</h2>
        <p class="text-gray-500 text-sm">請輸入您的登入資訊</p>
      </div>

      <!-- 表單區域 -->
      <div class="space-y-2">
        <!-- 公司選擇 -->
        <div class="space-y-1">
          <app-jkcombobox class="w-full" label="登入公司" [emojiLabel]="'🏢'" [(value)]="companySelected"
            [items]="lstCompany" (valueChange)="onUserOrCompanyChange()">
          </app-jkcombobox>
        </div>

        <!-- 使用者名稱 -->
        <div class="space-y-1">
          <app-jkedit [visible]="true" [label]="'使用者'" [emojiLabel]="'👤'" [required]="true" [value]="userId()"
            (valueChange)="userId.set($event); onUserOrCompanyChange()" class="w-full">
          </app-jkedit>
        </div>

        <!-- 密碼 -->
        <div class="space-y-1">
          <app-jkedit label="密碼" [emojiLabel]="'🔒'" [required]="true" type="password" [value]="password()"
            (valueChange)="password.set($event)" class="w-full">
          </app-jkedit>
        </div>

        <!-- 自動登入選項 -->
        <div class="flex items-center justify-between">
          <app-jkcheckbox color="primary" [value]="autoLogin()" (valueChange)="autoLogin.set($event)" label="自動登入">
          </app-jkcheckbox>
        </div>

        <!-- 錯誤訊息 -->
        @if (error) {
        <div class="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center space-x-2 error-message">
          <svg class="w-5 h-5 text-red-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <p class="text-red-700 text-sm">{{ error }}</p>
        </div>
        }

        <!-- 生物識別區域 -->
        @if (biometricSupported() && isMobile()) {
        <div class="bg-linear-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-xl p-4 space-y-3">
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-2">
              <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4">
                </path>
              </svg>
              <span class="text-sm font-medium text-purple-700">生物識別登入</span>
            </div>
            @if (hasBiometricCredential()) {
            <span class="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">已註冊</span>
            } @else {
            <span class="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">未註冊</span>
            }
          </div>

          @if (hasBiometricCredential()) {
          <!-- 生物識別登入按鈕 -->
          <button (click)="loginWithBiometric()" [disabled]="isBiometricLoading() || !userId().trim()"
            class="btn-neutral w-full h-12 text-white font-medium rounded-xl bg-linear-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 transform hover:scale-105 transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none">
            @if (isBiometricLoading()) {
            <div class="flex items-center justify-center space-x-2">
              <div class="loading-spinner"></div>
              <span>驗證中...</span>
            </div>
            } @else {
            <div class="flex items-center justify-center space-x-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z">
                </path>
              </svg>
              <span>指紋/Face ID 登入</span>
            </div>
            }
          </button>

          <!-- 移除生物識別按鈕 -->
          <button (click)="removeBiometric()" [disabled]="isBiometricLoading()"
            class="btn-primary w-full h-8 text-xs text-purple-600 border-purple-300 hover:bg-purple-50 rounded-lg transition-colors duration-200">
            移除生物識別
          </button>
          } @else {
          <!-- 註冊生物識別按鈕 -->
          <button (click)="registerBiometric()" [disabled]="isBiometricLoading() || !userId().trim()"
            class="btn-primary w-full h-10 text-purple-600 border-purple-300 hover:bg-purple-50 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (isBiometricLoading()) {
            <div class="flex items-center justify-center space-x-2">
              <div class="loading-spinner border-purple-600"></div>
              <span>註冊中...</span>
            </div>
            } @else {
            <div class="flex items-center justify-center space-x-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6">
                </path>
              </svg>
              <span>註冊指紋/Face ID</span>
            </div>
            }
          </button>
          }

          <div class="text-center">
            <span class="text-xs text-gray-500">或使用傳統方式登入</span>
          </div>
        </div>
        }

        <!-- 登入按鈕 class font-medium rounded-xl bg-linear-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none -->
        <button (click)="loginUser()" [disabled]="isLoading() || !userId().trim() || !password().trim()"

          class="btn-primary w-full h-12 text-lg ">
          @if (isLoading()) {
          <div class="flex items-center justify-center space-x-2">
            <div class="loading-spinner"></div>
            <span>登入中...</span>
          </div>
          } @else {
          <div class="flex items-center justify-center space-x-2">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
            </svg>
            <span>密碼登入</span>
          </div>
          }
        </button>
      </div>

      <!-- 登入狀態 -->
      <div class="border-t pt-2">
        <div class="flex items-center justify-center space-x-2">
          @if (isLogin) {
          <div
            class="flex items-center space-x-2 text-green-600 bg-green-50 px-4 py-2 rounded-full border border-green-200">
            <div class="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span class="font-medium">已登入</span>
          </div>
          }
          @if (!isLogin) {
          <div
            class="flex items-center space-x-2 text-gray-500 bg-gray-50 px-4 py-2 rounded-full border border-gray-200">
            <div class="w-2 h-2 bg-gray-400 rounded-full"></div>
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>未登入</span>
          </div>
          }
        </div>
      </div>

      <!-- 操作按鈕 flex-1 h-10 rounded-lg border-2 hover:bg-red-50 transition-colors duration-200 -->
      <div class="flex space-x-3 pt-4">
        <button [disabled]="!isLogin" (click)="logout()"
          class="btn-primary ">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
          登出
        </button>
        <button [disabled]="!isLogin" (click)="registerPage()"
          class="btn-primary">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
          </svg>
          註冊
        </button>
      </div>
    </div>

    <!-- 底部資訊 -->
    <div class="text-center mt-6 text-sm text-gray-500">
      <p>© 2025 jack168.com</p>
    </div>
  </div>
</div>
